@if (this | method: 'isBadgeModeAndBadgeAssetExists') {
  <div class="product-badge">
    <img
      appImage
      [asset]="nonListColumnBadgeAsset || listColumnBadgeAsset"
      [ngClass]="nonListColumnBadgeAsset ? ['badge', 'justify-self-center'] : ['list-badge']"
      alt="badge"
      src="" />
  </div>
} @else {
  <ng-content></ng-content>
}
